import { useSelector } from "react-redux";
import { LedgerForm } from "../../LedgerForm";

export const CardPayment = () => {
  const { allow_ledger_account } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );

  return (
    <section>
      <h5>Card Payment</h5>
      <p className="small-text-size mb-3" style={{ maxWidth: "450px" }}>
        Kindly confirm you have received the total amount in the payment summary
      </p>
      {allow_ledger_account ? <LedgerForm /> : null}
    </section>
  );
};
